module.exports = __webpack_public_path__ + "7fe4d1ac6a8c15a752f03044e5e6af07.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-17.png
// module id = 2594
// module chunks = 0